"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBreakpoint = exports.BreakpointProvider = exports.getBreakpoint = exports.getWindowWidth = exports["default"] = exports.BreakpointType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireWildcard(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _ExecutionEnvironment = require("fbjs/lib/ExecutionEnvironment");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _styles = require("@emcasa/ui/lib/styles");

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _class, _temp, _class2, _temp2;

var BreakpointType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);

exports.BreakpointType = BreakpointType;

var _default = (0, _styledComponents.withTheme)((_temp = _class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Breakpoint, _PureComponent);

  function Breakpoint() {
    (0, _classCallCheck2["default"])(this, Breakpoint);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Breakpoint).apply(this, arguments));
  }

  (0, _createClass2["default"])(Breakpoint, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          theme = _this$props.theme;
      var query;
      var keys = ['only', 'up', 'down'];

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var mode = _keys[_i];

        if (this.props[mode]) {
          query = _styles.breakpoint[mode](this.props[mode])({
            theme: theme
          });
          break;
        }
      }

      return _react["default"].createElement(_reactResponsive["default"], {
        query: query
      }, children);
    }
  }]);
  return Breakpoint;
}(_react.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", {
  up: BreakpointType,
  down: BreakpointType,
  only: BreakpointType
}), _temp));

exports["default"] = _default;

var getWindowWidth = function getWindowWidth() {
  if (_ExecutionEnvironment.canUseDOM) return window.innerWidth || document.documentElement.clientWidth;
};

exports.getWindowWidth = getWindowWidth;

var getBreakpoint = function getBreakpoint(_ref) {
  var windowWidth = _ref.width,
      theme = _ref.theme;
  var index = 0,
      name;
  var width = windowWidth || getWindowWidth();

  for (; index < theme.breakpointNames.length; ++index) {
    if (parseInt(theme.breakpoints[index]) >= width) break;
    name = theme.breakpointNames[index];
  }

  return {
    breakpoint: name,
    isMobile: _styles.breakpoint.isMobile(name)
  };
};

exports.getBreakpoint = getBreakpoint;
var BreakpointProvider = (0, _styledComponents.withTheme)((_temp2 = _class2 =
/*#__PURE__*/
function (_PureComponent2) {
  (0, _inherits2["default"])(BreakpointProvider, _PureComponent2);

  function BreakpointProvider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BreakpointProvider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BreakpointProvider).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      breakpoint: undefined,
      isMobile: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_addEvents", function () {
      window.addEventListener('resize', _this.update);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_removeEvents", function () {
      window.removeEventListener('resize', _this.update);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_update", function () {
      return _this.setState(getBreakpoint(_this.props));
    });
    _this.update = (0, _debounce["default"])(_this._update, props.debounce);
    if (_ExecutionEnvironment.canUseDOM && !props.disabled) _this.state = getBreakpoint(props);
    return _this;
  }

  (0, _createClass2["default"])(BreakpointProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.debounce !== this.props.debounce) {
        this._removeEvents();

        this.update.cancel();
        this.update = (0, _debounce["default"])(this._update, this.props.debounce);

        this._addEvents();
      } else if (prevProps.disabled !== this.props.disabled) {
        if (!this.props.disabled) this._addEvents();else this._removeEvents();
      }

      if (prevProps.width !== this.props.width) this._update();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_ExecutionEnvironment.canUseDOM && !this.props.disabled) this._addEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_ExecutionEnvironment.canUseDOM && !this.props.disabled) this._removeEvents();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state);
    }
  }]);
  return BreakpointProvider;
}(_react.PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  children: _propTypes["default"].func.isRequired,
  debounce: _propTypes["default"].number.isRequired,
  disabled: _propTypes["default"].bool
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  debounce: 150
}), _temp2));
exports.BreakpointProvider = BreakpointProvider;

var withBreakpoint = function withBreakpoint() {
  var getOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Target) {
    return (0, _hoistNonReactStatics["default"])(_react["default"].forwardRef(function (props, ref) {
      return _react["default"].createElement(BreakpointProvider, (0, _isFunction["default"])(getOptions) ? getOptions(props) : getOptions, function (ctx) {
        return _react["default"].createElement(Target, (0, _extends2["default"])({
          ref: ref
        }, props, ctx));
      });
    }), Target);
  };
};

exports.withBreakpoint = withBreakpoint;